<template>
  <div class="sub-title">
    <div class="date">
      <span v-if="extraItem.extras('displayTime.display', 1) == 1"
        >{{ pushTime.substr(0, 10) }}
      </span>
    </div>
    <div class="statistics">
      <span
        class="icontemp chakan"
        v-if="extraItem.extras('displayView.display', 1) == 1"
      ></span>
      <span v-if="extraItem.extras('displayView.display', 1) == 1">{{
        browseCount
      }}</span>
      <!--<span class="icontemp dianzan" v-if="isAllowedLike" :class="{'is-thumbs':!canLike}"  @click="like()"></span> <span v-if="isAllowedLike">{{ likeCount }}</span>-->
      <span
        class="icontemp dianzan"
        v-if="isAllowedLike && extraItem.extras('displayLike.display', 1) == 1"
      ></span>
      <span
        v-if="isAllowedLike && extraItem.extras('displayLike.display', 1) == 1"
        >{{ likeCount }}</span
      >
      <span class="icontemp xiaoxi" v-if="isAllowedComment"></span>
      <span v-if="isAllowedComment">{{ commentCount }}</span>
    </div>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import { articleId } from "../../common/sbase";
import service from "../../services/article";
import template from "../../mixin/template";
export default {
  name: "Subtitle",
  mixins: [template],
  data() {
    return {
      pushTime: "",
      likeCount: "",
      browseCount: "",
      commentCount: "",
      isAllowedComment: "",
      isAllowedLike: false,
      //      isAllowedLike: true,
      //      likeCount: 0,
      canLike: true,
      schemaId: "",
      isSubmitting: false,
      userInfo: {}
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.content = info.content;
        this.title = info.title;
        this.pushTime = info.pushTime;
        this.likeCount = info.likeCount;
        this.browseCount = info.statInfo.browseCount;
        this.isAllowedComment = info.isAllowedComment == 1;
        this.isAllowedLike = info.isAllowedLike == 1;
        //          this.isAllowedLike = info.isAllowedLike == 1;
        //          this.likeCount = info.likeCount;
        this.schemaId = info.schemaId;
        if (this.isAllowedLike) {
          $subscriber.subscribe("user-info", info => {
            if (info) {
              this.userInfo = info;
              this.getLikeStatus(info);
            }
          });
        }
      }
      $subscriber.subscribe("comment-count", info => {
        this.commentCount = info;
      });
      $subscriber.subscribe("like-count", info => {
        this.likeCount = info;
      });
    });
  },
  methods: {
    like() {
      if (!this.canLike || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      let param = {
        articleId: articleId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.session || "",
        weChatId: "",
        resolution: window.screen.width + "*" + window.screen.height
      };
      service.like(param).subscribe(data => {
        if (data.result == 0) {
          this.likeCount = parseInt(this.likeCount) + 1;
          $subscriber.emit("like-count", this.likeCount);
          this.canLike = false;
        }
        setTimeout(() => {
          this.isSubmitting = false;
        }, 500);
      });
    },
    getLikeStatus() {
      let self = this;
      let param = {
        articleId: articleId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.session
      };
      service.getLikeStatus(param).subscribe(data => {
        self.canLike = Number(data.content.canLike) === 1;
      });
    }
  },
  components: {}
};
</script>
